import LoanImg1 from "../assets/img/pl_banner.webp";
import LoanImg2 from "../assets/img/loan_img2.webp";
import LoanImg3 from "../assets/img/loan_img1.jpg";
import InsuranceImg from "../assets/img/insurance_bg.jpg";
import LoanImg4 from "../assets/img/loan_img.png";
import LoanImg5 from "../assets/img/bl_banner.jpg";
import Director1 from "../assets/img/shivam.jpeg";
import Director2 from "../assets/img/aayushi.jpeg";
import Logo from "../assets/img/logo.png";

const Image = {
  Logo,
	LoanImg1,
	LoanImg2,
	LoanImg3,
	InsuranceImg,
	LoanImg4,
	LoanImg5,
	Director1,
	Director2,
};

export default Image;
